// Port de app/(tabs)/atestado.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const AtestadoMedicoScreen = lazy(() => import("@/screens/AtestadoMedico"));

export default function AtestadoRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <AtestadoMedicoScreen />
    </Carregando>
  ) : null;
}
